"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.titleAndTextPropType = exports.specificationPropType = exports.pricePropType = exports.modelPropType = exports.feePropType = exports.dataPropType = exports.compareLinkPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var compareLinkPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool
});
exports.compareLinkPropType = compareLinkPropType;
var titleAndTextPropType = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  text: _propTypes["default"].string
});
exports.titleAndTextPropType = titleAndTextPropType;
var feePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number
});
exports.feePropType = feePropType;
var pricePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  baseValue: _propTypes["default"].number,
  displayValue: _propTypes["default"].string,
  fees: _propTypes["default"].arrayOf(feePropType)
});
exports.pricePropType = pricePropType;
var specificationPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  label: _propTypes["default"].string,
  titleAndText: _propTypes["default"].any
});
exports.specificationPropType = specificationPropType;
var modelPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  code: _propTypes["default"].string,
  name: _propTypes["default"].string,
  year: _propTypes["default"].string,
  price: pricePropType,
  description: _propTypes["default"].string,
  descriptionList: _propTypes["default"].any,
  monthlyPaymentTerms: _propTypes["default"].string,
  cabType: _propTypes["default"].string,
  engineSize: _propTypes["default"].string,
  engineCode: _propTypes["default"].string,
  engineType: _propTypes["default"].string,
  fuelType: _propTypes["default"].string,
  transmissionType: _propTypes["default"].string,
  transmissionCode: _propTypes["default"].string,
  transmissionDescription: _propTypes["default"].string,
  drivetrain: _propTypes["default"].string,
  seats: _propTypes["default"].number,
  doors: _propTypes["default"].number,
  defaultMonthlyLeasePayment: _propTypes["default"].number,
  selected: _propTypes["default"].bool,
  tag: _propTypes["default"].any,
  image: _propTypes["default"].any,
  specifications: _propTypes["default"].arrayOf(specificationPropType)
});
exports.modelPropType = modelPropType;
var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  headingText: titleAndTextPropType,
  titleAndText: titleAndTextPropType,
  models: _propTypes["default"].arrayOf(modelPropType),
  changeEvent: _propTypes["default"].func,
  selectedCard: _propTypes["default"].string
});
exports.dataPropType = dataPropType;